import { render, staticRenderFns } from "./CloudAlbum.vue?vue&type=template&id=53f7a71a&scoped=true"
import script from "./CloudAlbum.vue?vue&type=script&lang=js"
export * from "./CloudAlbum.vue?vue&type=script&lang=js"
import style0 from "./CloudAlbum.vue?vue&type=style&index=0&id=53f7a71a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7a71a",
  null
  
)

export default component.exports